module.exports = __webpack_public_path__ + "img/R-1.2392ac28.png";